import { env } from "./env";

/**
 * Páginas públicas (imobgo-public) são servidas no apex sob o prefixo /public
 * (Next basePath). A base vem de `VITE_PUBLIC_SITE_URL` — NÃO usar
 * `window.location.origin`, que no app resolve para `app.imobgo.app` (host
 * errado) em vez de `imobgo.app`. (hub#307)
 */
const PUBLIC_BASE_PATH = "/public";

const siteBase = env.VITE_PUBLIC_SITE_URL.replace(/\/+$/, "");

/** URL pública da vitrine permanente do imóvel: `{site}/public/p/{shareCode}` (sem endereço exato). */
export function publicPropertyUrl(shareCode: string): string {
  return `${siteBase}${PUBLIC_BASE_PATH}/p/${shareCode}`;
}

/**
 * URL de um link compartilhado por **share-token**: `{site}/public/share/{token}`.
 * A visibilidade do endereço é decidida no servidor pelo token (ShowAddress) —
 * NUNCA por query na URL. Use sempre que houver um token. (hub#24)
 */
export function publicShareUrl(token: string): string {
  return `${siteBase}${PUBLIC_BASE_PATH}/share/${token}`;
}

/**
 * URL de um link compartilhado de **lançamento** por share-token:
 * `{site}/public/launch/{token}`. Espelha `publicShareUrl` (imóvel): a página
 * pública é servida pelo imobgo-public sob `/public` — a base vem de
 * `VITE_PUBLIC_SITE_URL`, NUNCA de `window.location.origin`. (hub#610)
 */
export function publicLaunchShareUrl(token: string): string {
  return `${siteBase}${PUBLIC_BASE_PATH}/launch/${token}`;
}

/**
 * URL de auto-cadastro de pessoa (lead): `{site}/public/lead/{token}` — a página
 * pública (imobgo-public) que o prospect preenche. Contrato em
 * `hub/docs/architecture/public-url-contract.md`. (hub#56)
 */
export function publicRegistrationUrl(token: string): string {
  return `${siteBase}${PUBLIC_BASE_PATH}/lead/${token}`;
}

/**
 * URL do formulário do corretor parceiro EXTERNO na proposta:
 * `{site}/public/proposal-partner/{token}` — a página (imobgo-public) onde o parceiro
 * que não usa o ImobGo cadastra os próprios dados + os do cliente interessado. (hub#412)
 */
export function publicProposalPartnerUrl(token: string): string {
  return `${siteBase}${PUBLIC_BASE_PATH}/proposal-partner/${token}`;
}

/**
 * URL pública da PROPOSTA (read-only) para enviar ao cliente/proprietário:
 * `{site}/public/proposal/{token}` — mostra o imóvel + as versões em negociação. (hub#477)
 */
export function publicProposalUrl(token: string): string {
  return `${siteBase}${PUBLIC_BASE_PATH}/proposal/${token}`;
}

/**
 * URL de confirmação de acesso ao imóvel (portaria/condomínio): `{app}/p/acesso/{token}`.
 * Diferente dos demais fluxos, a página vive NESTE SPA (rota `/p/acesso/:token`,
 * `PropertyAccessConfirmPage`) — decisão registrada no contrato do hub ("não migrar
 * para o imobgo-public"). Aqui `window.location.origin` é o host correto por definição;
 * a regra "nunca usar origin" vale só para links do imobgo-public.
 */
export function accessAuthorizationUrl(token: string): string {
  if (typeof window === "undefined") return `/p/acesso/${token}`;
  return `${window.location.origin}/p/acesso/${token}`;
}
